(() => {
  const rootElement =
    document.documentElement;

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const productSelector =
    '[data-julu-product-root]';

  const productControllers =
    new WeakMap();

  const sectionCache =
    new Map();


  const getRouteRoot = () => {
    return (
      window.Shopify?.routes?.root ||
      '/'
    );
  };

  const formatMoney = (
    cents,
    currency = 'INR'
  ) => {
    const amount =
      Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang ||
        'en-IN',
        {
          style: 'currency',
          currency,
          minimumFractionDigits:
            Number.isInteger(amount)
              ? 0
              : 2,
          maximumFractionDigits: 2
        }
      ).format(amount);
    } catch (error) {
      return `₹${amount.toFixed(
        Number.isInteger(amount)
          ? 0
          : 2
      )}`;
    }
  };


  const initHeader = (
    scope = document
  ) => {
    const headers = [];

    if (
      scope.matches?.(
        '[data-julu-header]'
      )
    ) {
      headers.push(
        scope
      );
    }

    scope
      .querySelectorAll?.(
        '[data-julu-header]'
      )
      .forEach(
        (header) => {
          headers.push(
            header
          );
        }
      );


    headers.forEach(
      (header) => {
        if (
          header.dataset
            .juluHeaderInitialized ===
          'true'
        ) {
          return;
        }

        header.dataset
          .juluHeaderInitialized =
          'true';

        const headerSection =
          header.closest(
            '.shopify-section'
          );

        if (
          header.classList.contains(
            'julu-header--sticky'
          )
        ) {
          headerSection?.classList.add(
            'julu-header-section--sticky'
          );
        } else {
          headerSection?.classList.remove(
            'julu-header-section--sticky'
          );
        }


        const mobileMenu =
          header.querySelector(
            '[data-julu-mobile-menu]'
          );

        const mobileToggle =
          mobileMenu?.querySelector(
            '.julu-header__mobile-toggle'
          );

        const mobilePanel =
          mobileMenu?.querySelector(
            '[data-julu-mobile-panel]'
          );

        const closeButtons =
          header.querySelectorAll(
            '[data-julu-mobile-menu-close]'
          );

        const details =
          Array.from(
            header.querySelectorAll(
              '[data-julu-header-details]'
            )
          );

        const tabs =
          Array.from(
            header.querySelectorAll(
              '[data-julu-mobile-tab]'
            )
          );

        const tabPanels =
          Array.from(
            header.querySelectorAll(
              '[data-julu-mobile-panel-name]'
            )
          );

        const accordionTriggers =
          Array.from(
            header.querySelectorAll(
              '[data-julu-mobile-accordion-trigger]'
            )
          );


        const setScrolledState =
          () => {
            header.classList.toggle(
              'is-scrolled',
              window.scrollY > 4
            );
          };


        const activateTab =
          (tabName) => {
            tabs.forEach(
              (tab) => {
                const active =
                  tab.dataset
                    .juluMobileTab ===
                  tabName;

                tab.classList.toggle(
                  'is-active',
                  active
                );

                tab.setAttribute(
                  'aria-selected',
                  active
                    ? 'true'
                    : 'false'
                );
              }
            );

            tabPanels.forEach(
              (panel) => {
                const active =
                  panel.dataset
                    .juluMobilePanelName ===
                  tabName;

                panel.classList.toggle(
                  'is-active',
                  active
                );

                panel.hidden =
                  !active;
              }
            );
          };


        const closeAccordion =
          (
            trigger,
            accordion
          ) => {
            const panelId =
              trigger.getAttribute(
                'aria-controls'
              );

            const panel =
              panelId
                ? document.getElementById(
                  panelId
                )
                : null;

            trigger.setAttribute(
              'aria-expanded',
              'false'
            );

            accordion?.classList
              .remove(
                'is-open'
              );

            if (panel) {
              panel.hidden = true;
            }
          };


        const openAccordion =
          (
            trigger,
            accordion
          ) => {
            const panelId =
              trigger.getAttribute(
                'aria-controls'
              );

            const panel =
              panelId
                ? document.getElementById(
                  panelId
                )
                : null;

            trigger.setAttribute(
              'aria-expanded',
              'true'
            );

            accordion?.classList
              .add(
                'is-open'
              );

            if (panel) {
              panel.hidden = false;
            }
          };


        const closeMobileMenu =
          (
            restoreFocus = true
          ) => {
            if (!mobileMenu) {
              return;
            }

            mobileMenu.removeAttribute(
              'open'
            );

            mobileToggle?.setAttribute(
              'aria-expanded',
              'false'
            );

            rootElement.classList.remove(
              'julu-mobile-menu-open'
            );

            if (
              restoreFocus &&
              mobileToggle
            ) {
              window.requestAnimationFrame(
                () => {
                  mobileToggle.focus();
                }
              );
            }
          };


        const openMobileMenu =
          () => {
            if (!mobileMenu) {
              return;
            }

            mobileToggle?.setAttribute(
              'aria-expanded',
              'true'
            );

            rootElement.classList.add(
              'julu-mobile-menu-open'
            );

            activateTab(
              'shop'
            );

            window.requestAnimationFrame(
              () => {
                const firstFocusable =
                  mobilePanel?.querySelector(
                    'button:not([disabled])'
                  );

                firstFocusable?.focus();
              }
            );
          };


        closeButtons.forEach(
          (button) => {
            button.addEventListener(
              'click',
              () => {
                closeMobileMenu(
                  true
                );
              }
            );
          }
        );


        mobileMenu?.addEventListener(
          'toggle',
          () => {
            if (
              mobileMenu.open
            ) {
              openMobileMenu();
            } else {
              mobileToggle?.setAttribute(
                'aria-expanded',
                'false'
              );

              rootElement.classList.remove(
                'julu-mobile-menu-open'
              );
            }
          }
        );


        tabs.forEach(
          (tab) => {
            tab.addEventListener(
              'click',
              () => {
                activateTab(
                  tab.dataset
                    .juluMobileTab
                );
              }
            );
          }
        );


        accordionTriggers.forEach(
          (trigger) => {
            trigger.addEventListener(
              'click',
              () => {
                const accordion =
                  trigger.closest(
                    '.julu-header__mobile-accordion'
                  );

                const currentlyOpen =
                  trigger.getAttribute(
                    'aria-expanded'
                  ) === 'true';


                accordionTriggers
                  .forEach(
                    (
                      otherTrigger
                    ) => {
                      if (
                        otherTrigger ===
                        trigger
                      ) {
                        return;
                      }

                      closeAccordion(
                        otherTrigger,
                        otherTrigger.closest(
                          '.julu-header__mobile-accordion'
                        )
                      );
                    }
                  );


                if (
                  currentlyOpen
                ) {
                  closeAccordion(
                    trigger,
                    accordion
                  );
                } else {
                  openAccordion(
                    trigger,
                    accordion
                  );
                }
              }
            );
          }
        );


        details.forEach(
          (currentDetail) => {
            currentDetail.addEventListener(
              'toggle',
              () => {
                if (
                  !currentDetail.open
                ) {
                  return;
                }

                details.forEach(
                  (otherDetail) => {
                    if (
                      otherDetail !==
                      currentDetail
                    ) {
                      otherDetail.removeAttribute(
                        'open'
                      );
                    }
                  }
                );
              }
            );
          }
        );


        window.addEventListener(
          'scroll',
          setScrolledState,
          {
            passive: true
          }
        );

        setScrolledState();
      }
    );


    if (
      rootElement.dataset
        .juluHeaderGlobalInitialized ===
      'true'
    ) {
      return;
    }

    rootElement.dataset
      .juluHeaderGlobalInitialized =
      'true';


    document.addEventListener(
      'pointerdown',
      (event) => {
        const header =
          document.querySelector(
            '[data-julu-header]'
          );

        if (!header) {
          return;
        }

        const desktopShop =
          header.querySelector(
            '.julu-header__shop[open]'
          );

        if (
          desktopShop &&
          !desktopShop.contains(
            event.target
          )
        ) {
          desktopShop.removeAttribute(
            'open'
          );
        }
      }
    );





    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key !==
          'Escape'
        ) {
          return;
        }

        const header =
          document.querySelector(
            '[data-julu-header]'
          );

        if (!header) {
          return;
        }

        const mobileMenu =
          header.querySelector(
            '[data-julu-mobile-menu]'
          );

        const mobileToggle =
          mobileMenu?.querySelector(
            '.julu-header__mobile-toggle'
          );

        const mobileWasOpen =
          Boolean(
            mobileMenu?.open
          );

        header
          .querySelectorAll(
            '[data-julu-header-details]'
          )
          .forEach(
            (detail) => {
              detail.removeAttribute(
                'open'
              );
            }
          );

        rootElement.classList.remove(
          'julu-mobile-menu-open'
        );

        mobileToggle?.setAttribute(
          'aria-expanded',
          'false'
        );

        if (
          mobileWasOpen
        ) {
          window.requestAnimationFrame(
            () => {
              mobileToggle?.focus();
            }
          );
        }
      }
    );

  };










  const initAnnouncementBars = (
    scope = document
  ) => {
    const bars = [];

    if (
      scope.matches?.(
        '[data-julu-announcement]'
      )
    ) {
      bars.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-julu-announcement]'
      )
      .forEach(
        (bar) => {
          bars.push(bar);
        }
      );


    bars.forEach(
      (bar) => {
        if (
          bar.dataset
            .juluAnnouncementInitialized ===
          'true'
        ) {
          return;
        }

        bar.dataset
          .juluAnnouncementInitialized =
          'true';

        const slides =
          Array.from(
            bar.querySelectorAll(
              '[data-julu-announcement-item]'
            )
          );

        const previous =
          bar.querySelector(
            '[data-julu-announcement-previous], [data-julu-announcement-prev]'
          );

        const next =
          bar.querySelector(
            '[data-julu-announcement-next]'
          );

        const autoplay =
          bar.dataset.autoplay ===
          'true' ||
          bar.dataset.autoRotate ===
          'true';

        const interval =
          Math.max(
            2500,
            Number(
              bar.dataset.interval ||
              bar.dataset
                .autoplayInterval ||
              5000
            )
          );

        let activeIndex =
          Math.max(
            0,
            slides.findIndex(
              (slide) =>
                slide.classList.contains(
                  'is-active'
                )
            )
          );

        let timer = null;


        const showSlide = (
          requestedIndex
        ) => {
          if (
            slides.length <= 1
          ) {
            return;
          }

          activeIndex =
            (
              requestedIndex %
              slides.length +
              slides.length
            ) %
            slides.length;

          slides.forEach(
            (slide, index) => {
              const active =
                index === activeIndex;

              slide.classList.toggle(
                'is-active',
                active
              );

              slide.setAttribute(
                'aria-hidden',
                active
                  ? 'false'
                  : 'true'
              );
            }
          );
        };


        const stopAutoplay =
          () => {
            if (!timer) {
              return;
            }

            window.clearInterval(
              timer
            );

            timer = null;
          };


        const startAutoplay =
          () => {
            stopAutoplay();

            if (
              !autoplay ||
              slides.length <= 1 ||
              reducedMotion.matches
            ) {
              return;
            }

            timer =
              window.setInterval(
                () => {
                  showSlide(
                    activeIndex + 1
                  );
                },
                interval
              );
          };


        previous?.addEventListener(
          'click',
          () => {
            showSlide(
              activeIndex - 1
            );

            startAutoplay();
          }
        );


        next?.addEventListener(
          'click',
          () => {
            showSlide(
              activeIndex + 1
            );

            startAutoplay();
          }
        );


        bar.addEventListener(
          'mouseenter',
          stopAutoplay
        );

        bar.addEventListener(
          'mouseleave',
          startAutoplay
        );

        bar.addEventListener(
          'focusin',
          stopAutoplay
        );

        bar.addEventListener(
          'focusout',
          startAutoplay
        );


        const copyButtons =
          bar.querySelectorAll(
            '[data-julu-copy]'
          );

        copyButtons.forEach(
          (button) => {
            button.addEventListener(
              'click',
              async () => {
                const explicitValue =
                  button.dataset
                    .copyValue;

                const valueElement =
                  button.querySelector(
                    '[data-julu-copy-value]'
                  );

                const copyValue =
                  explicitValue ||
                  valueElement
                    ?.textContent
                    ?.trim() ||
                  '';

                if (!copyValue) {
                  return;
                }

                try {
                  await navigator
                    .clipboard
                    .writeText(
                      copyValue
                    );
                } catch (error) {
                  const textarea =
                    document.createElement(
                      'textarea'
                    );

                  textarea.value =
                    copyValue;

                  textarea.setAttribute(
                    'readonly',
                    ''
                  );

                  textarea.style.position =
                    'fixed';

                  textarea.style.opacity =
                    '0';

                  document.body
                    .appendChild(
                      textarea
                    );

                  textarea.select();

                  document.execCommand(
                    'copy'
                  );

                  textarea.remove();
                }

                button.classList.add(
                  'is-copied'
                );

                button.setAttribute(
                  'aria-label',
                  'Copied'
                );

                window.setTimeout(
                  () => {
                    button.classList
                      .remove(
                        'is-copied'
                      );

                    button.setAttribute(
                      'aria-label',
                      'Copy code'
                    );
                  },
                  1600
                );
              }
            );
          }
        );

        startAutoplay();
      }
    );
  };


  const applyGlobalTheme = (
    productRoot
  ) => {
    const header =
      document.querySelector(
        '[data-julu-header]'
      );

    const announcement =
      document.querySelector(
        '[data-julu-announcement]'
      );

    const experience =
      document.querySelector(
        '.julu-experience'
      );


    if (header) {
      const properties = {
        '--julu-header-background':
          productRoot.dataset
            .headerBackground,

        '--julu-header-text':
          productRoot.dataset
            .headerText,

        '--julu-header-icon':
          productRoot.dataset
            .headerIcon,

        '--julu-header-hover':
          productRoot.dataset
            .headerHover,

        '--julu-header-cta-background':
          productRoot.dataset
            .headerCtaBackground,

        '--julu-header-cta-text':
          productRoot.dataset
            .headerCtaText
      };

      Object.entries(
        properties
      ).forEach(
        ([property, value]) => {
          if (!value) {
            return;
          }

          header.style.setProperty(
            property,
            value
          );
        }
      );
    }


    if (announcement) {
      if (
        productRoot.dataset
          .announcementBackground
      ) {
        announcement.style
          .setProperty(
            '--julu-announcement-background',
            productRoot.dataset
              .announcementBackground
          );
      }

      if (
        productRoot.dataset
          .announcementText
      ) {
        announcement.style
          .setProperty(
            '--julu-announcement-text',
            productRoot.dataset
              .announcementText
          );
      }
    }


    if (experience) {
      if (
        productRoot.dataset
          .productBackground
      ) {
        experience.style
          .setProperty(
            '--julu-experience-background',
            productRoot.dataset
              .productBackground
          );
      }

      if (
        productRoot.dataset
          .productText
      ) {
        experience.style
          .setProperty(
            '--julu-experience-text',
            productRoot.dataset
              .productText
          );
      }
    }
  };


  const parseProductData = (
    productRoot
  ) => {
    const script =
      productRoot.querySelector(
        '[data-julu-product-data]'
      );

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(
        script.textContent
      );
    } catch (error) {
      console.warn(
        'Julu product data could not be parsed.',
        error
      );

      return null;
    }
  };


  const setGalleryImage = (
    productRoot,
    imageUrl,
    imageAlt = '',
    imageRatio = 1
  ) => {
    const mainImage =
      productRoot.querySelector(
        '[data-julu-main-image]'
      );

    const media =
      productRoot.querySelector(
        '[data-julu-main-media]'
      );

    if (
      !mainImage ||
      !imageUrl
    ) {
      return;
    }

    mainImage.classList.add(
      'is-changing'
    );

    const preload =
      new Image();


    preload.onload = () => {
      mainImage.src =
        imageUrl;

      mainImage.srcset = '';

      mainImage.alt =
        imageAlt;

      if (
        media &&
        Number(imageRatio) > 0
      ) {
        media.style.setProperty(
          '--julu-product-media-ratio',
          Number(imageRatio)
        );
      }

      requestAnimationFrame(
        () => {
          mainImage.classList.remove(
            'is-changing'
          );
        }
      );
    };


    preload.onerror = () => {
      mainImage.classList.remove(
        'is-changing'
      );
    };


    preload.src =
      imageUrl;
  };


  const initializeGallery = (
    productRoot
  ) => {
    const thumbnails =
      Array.from(
        productRoot.querySelectorAll(
          '[data-julu-gallery-thumbnail]'
        )
      );

    if (!thumbnails.length) {
      return;
    }

    let activeIndex =
      Math.max(
        0,
        thumbnails.findIndex(
          (thumbnail) =>
            thumbnail.classList
              .contains(
                'is-active'
              )
        )
      );


    const showIndex = (
      requestedIndex
    ) => {
      activeIndex =
        (
          requestedIndex %
          thumbnails.length +
          thumbnails.length
        ) %
        thumbnails.length;

      thumbnails.forEach(
        (
          thumbnail,
          index
        ) => {
          const active =
            index === activeIndex;

          thumbnail.classList.toggle(
            'is-active',
            active
          );

          thumbnail.setAttribute(
            'aria-current',
            active
              ? 'true'
              : 'false'
          );
        }
      );

      const thumbnail =
        thumbnails[activeIndex];

      setGalleryImage(
        productRoot,
        thumbnail.dataset
          .mediaSrc,
        thumbnail.dataset
          .mediaAlt,
        thumbnail.dataset
          .mediaRatio
      );

      thumbnail.scrollIntoView({
        behavior:
          reducedMotion.matches
            ? 'auto'
            : 'smooth',

        block: 'nearest',
        inline: 'nearest'
      });
    };


    thumbnails.forEach(
      (
        thumbnail,
        index
      ) => {
        thumbnail.addEventListener(
          'click',
          () => {
            showIndex(index);
          }
        );
      }
    );


    productRoot
      .querySelector(
        '[data-julu-gallery-previous]'
      )
      ?.addEventListener(
        'click',
        () => {
          showIndex(
            activeIndex - 1
          );
        }
      );


    productRoot
      .querySelector(
        '[data-julu-gallery-next]'
      )
      ?.addEventListener(
        'click',
        () => {
          showIndex(
            activeIndex + 1
          );
        }
      );

    const mainMedia =
      productRoot.querySelector(
        '[data-julu-main-media]'
      );

    if (mainMedia) {
      let pointerStartX = 0;
      let pointerStartY = 0;
      let didSwipe = false;

      const swipeThreshold = 40;

      mainMedia.addEventListener(
        'pointerdown',
        (event) => {
          if (
            event.pointerType !== 'touch'
          ) {
            return;
          }

          pointerStartX =
            event.clientX;

          pointerStartY =
            event.clientY;

          didSwipe = false;
        }
      );

      mainMedia.addEventListener(
        'pointerup',
        (event) => {
          if (
            event.pointerType !== 'touch'
          ) {
            return;
          }

          const deltaX =
            event.clientX -
            pointerStartX;

          const deltaY =
            event.clientY -
            pointerStartY;

          if (
            Math.abs(deltaX) <
            swipeThreshold ||
            Math.abs(deltaX) <=
            Math.abs(deltaY)
          ) {
            return;
          }

          didSwipe = true;

          if (deltaX < 0) {
            showIndex(
              activeIndex + 1
            );
          } else {
            showIndex(
              activeIndex - 1
            );
          }
        }
      );

      mainMedia.addEventListener(
        'click',
        (event) => {
          if (!didSwipe) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          didSwipe = false;
        },
        true
      );
    }








    const zoomTrigger =
      productRoot.querySelector(
        '[data-julu-gallery-zoom-open]'
      );

    if (zoomTrigger) {
      zoomTrigger.addEventListener(
        'pointermove',
        (event) => {
          if (
            event.pointerType !== 'mouse'
          ) {
            return;
          }

          const bounds =
            zoomTrigger.getBoundingClientRect();

          zoomTrigger.style.setProperty(
            '--julu-zoom-cursor-x',
            `${event.clientX - bounds.left}px`
          );

          zoomTrigger.style.setProperty(
            '--julu-zoom-cursor-y',
            `${event.clientY - bounds.top}px`
          );
        }
      );
    }

  };










  const initializeZoomGallery = (
    productRoot
  ) => {
    const dialog =
      productRoot.querySelector(
        '[data-julu-product-zoom]'
      );

    const openButton =
      productRoot.querySelector(
        '[data-julu-gallery-zoom-open]'
      );

    const viewport =
      dialog?.querySelector(
        '[data-julu-zoom-viewport]'
      );

    const zoomImage =
      dialog?.querySelector(
        '[data-julu-zoom-image]'
      );

    const thumbnails =
      Array.from(
        dialog?.querySelectorAll(
          '[data-julu-zoom-thumbnail]'
        ) || []
      );

    if (
      !dialog ||
      !openButton ||
      !viewport ||
      !zoomImage
    ) {
      return;
    }

    let activeIndex = 0;

    let scale = 1;

    let translateX = 0;
    let translateY = 0;

    let dragging = false;

    let pointerStartX = 0;
    let pointerStartY = 0;

    let desktopClickStartX = 0;
    let desktopClickStartY = 0;
    let desktopClickTracking = false;

    let translateStartX = 0;
    let translateStartY = 0;

    const pointers =
      new Map();

    let pinchStartDistance = 0;
    let pinchStartScale = 1;

    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipeTracking = false;

    const swipeThreshold = 48;

    const counter =
      dialog.querySelector(
        '[data-julu-zoom-counter]'
      );

    const resetButton =
      dialog.querySelector(
        '[data-julu-zoom-reset]'
      );

    const updateTransform =
      () => {
        zoomImage.style.setProperty(
          '--julu-zoom-scale',
          scale
        );

        zoomImage.style.setProperty(
          '--julu-zoom-x',
          `${translateX}px`
        );

        zoomImage.style.setProperty(
          '--julu-zoom-y',
          `${translateY}px`
        );

        if (resetButton) {
          resetButton.textContent =
            `${Math.round(
              scale * 100
            )}%`;
        }
      };

    const resetZoom = () => {
      scale = 1;

      translateX = 0;
      translateY = 0;

      updateTransform();
    };

    const setScale = (
      requestedScale
    ) => {
      scale =
        Math.min(
          5,
          Math.max(
            1,
            requestedScale
          )
        );

      if (scale === 1) {
        translateX = 0;
        translateY = 0;
      }

      updateTransform();
    };

    const showImage = (
      requestedIndex
    ) => {
      if (!thumbnails.length) {
        const currentThumbnail =
          productRoot.querySelector(
            '[data-julu-gallery-thumbnail].is-active'
          );

        const src =
          currentThumbnail
            ?.dataset
            .mediaZoomSrc ||
          currentThumbnail
            ?.dataset
            .mediaSrc ||
          productRoot.querySelector(
            '[data-julu-main-image]'
          )?.currentSrc ||
          productRoot.querySelector(
            '[data-julu-main-image]'
          )?.src;

        if (!src) {
          return;
        }

        resetZoom();

        zoomImage.src =
          src;

        zoomImage.alt =
          currentThumbnail
            ?.dataset
            .mediaAlt ||
          productRoot.dataset
            .productTitle ||
          '';

        if (counter) {
          counter.textContent =
            '1 / 1';
        }

        return;
      }

      activeIndex =
        (
          requestedIndex %
          thumbnails.length +
          thumbnails.length
        ) %
        thumbnails.length;

      const thumbnail =
        thumbnails[activeIndex];

      resetZoom();

      zoomImage.src =
        thumbnail.dataset
          .mediaSrc;

      zoomImage.alt =
        thumbnail.dataset
          .mediaAlt ||
        '';

      thumbnails.forEach(
        (
          currentThumbnail,
          index
        ) => {
          const active =
            index === activeIndex;

          currentThumbnail
            .classList
            .toggle(
              'is-active',
              active
            );

          currentThumbnail
            .setAttribute(
              'aria-current',
              active
                ? 'true'
                : 'false'
            );
        }
      );

      if (counter) {
        counter.textContent =
          `${activeIndex + 1} / ${thumbnails.length}`;
      }

      thumbnail.scrollIntoView({
        behavior:
          reducedMotion.matches
            ? 'auto'
            : 'smooth',

        block: 'nearest',
        inline: 'center'
      });
    };

    const getCurrentMainIndex =
      () => {
        const currentThumbnail =
          productRoot.querySelector(
            '[data-julu-gallery-thumbnail].is-active'
          );

        if (!currentThumbnail) {
          return 0;
        }

        const currentMediaId =
          currentThumbnail.dataset
            .mediaId;

        if (currentMediaId) {
          const mediaIndex =
            thumbnails.findIndex(
              (thumbnail) =>
                thumbnail.dataset
                  .mediaId ===
                currentMediaId
            );

          if (mediaIndex >= 0) {
            return mediaIndex;
          }
        }

        const currentIndex =
          Number(
            currentThumbnail.dataset
              .mediaIndex
          );

        return Number.isInteger(
          currentIndex
        )
          ? Math.min(
            Math.max(
              currentIndex,
              0
            ),
            Math.max(
              thumbnails.length - 1,
              0
            )
          )
          : 0;
      };



    const openGallery = () => {
      showImage(
        getCurrentMainIndex()
      );

      if (
        typeof dialog.showModal ===
        'function'
      ) {
        dialog.showModal();
      } else {
        dialog.setAttribute(
          'open',
          ''
        );
      }

      rootElement.classList.add(
        'julu-product-zoom-open'
      );
    };

    const closeGallery = () => {
      resetZoom();

      pointers.clear();

      swipeTracking = false;
      dragging = false;

      viewport.classList.remove(
        'is-dragging'
      );

      zoomImage.removeAttribute(
        'src'
      );

      if (dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute(
          'open'
        );
      }

      rootElement.classList.remove(
        'julu-product-zoom-open'
      );
    };

    const pointerDistance =
      () => {
        const points =
          Array.from(
            pointers.values()
          );

        if (
          points.length < 2
        ) {
          return 0;
        }

        return Math.hypot(
          points[0].x -
          points[1].x,

          points[0].y -
          points[1].y
        );
      };

    openButton.addEventListener(
      'click',
      openGallery
    );

    dialog
      .querySelector(
        '[data-julu-zoom-close]'
      )
      ?.addEventListener(
        'click',
        closeGallery
      );

    dialog
      .querySelector(
        '[data-julu-zoom-previous]'
      )
      ?.addEventListener(
        'click',
        () => {
          showImage(
            activeIndex - 1
          );
        }
      );

    dialog
      .querySelector(
        '[data-julu-zoom-next]'
      )
      ?.addEventListener(
        'click',
        () => {
          showImage(
            activeIndex + 1
          );
        }
      );

    dialog
      .querySelector(
        '[data-julu-zoom-in]'
      )
      ?.addEventListener(
        'click',
        () => {
          setScale(
            scale + 0.5
          );
        }
      );

    dialog
      .querySelector(
        '[data-julu-zoom-out]'
      )
      ?.addEventListener(
        'click',
        () => {
          setScale(
            scale - 0.5
          );
        }
      );

    resetButton?.addEventListener(
      'click',
      resetZoom
    );

    thumbnails.forEach(
      (
        thumbnail,
        index
      ) => {
        thumbnail.addEventListener(
          'click',
          () => {
            showImage(index);
          }
        );
      }
    );

    viewport.addEventListener(
      'wheel',
      (event) => {
        event.preventDefault();

        setScale(
          scale +
          (
            event.deltaY > 0
              ? -0.25
              : 0.25
          )
        );
      },
      {
        passive: false
      }
    );









    viewport.addEventListener(
      'pointerdown',
      (event) => {
        if (
          event.target.closest(
            '[data-julu-zoom-previous], [data-julu-zoom-next]'
          )
        ) {
          return;
        }

        const desktop =
          window.matchMedia(
            '(min-width: 990px)'
          ).matches;

        const clickedZoomImage =
          Boolean(
            event.target.closest(
              '[data-julu-zoom-image]'
            )
          );

        desktopClickTracking =
          desktop &&
          clickedZoomImage;

        if (desktopClickTracking) {
          desktopClickStartX =
            event.clientX;

          desktopClickStartY =
            event.clientY;
        }

        pointers.set(
          event.pointerId,
          {
            x: event.clientX,
            y: event.clientY
          }
        );

        if (
          event.pointerType !== 'mouse' ||
          scale > 1
        ) {
          viewport.setPointerCapture(
            event.pointerId
          );
        }




        if (
          event.pointerType ===
          'touch' &&
          !window.matchMedia(
            '(min-width: 990px)'
          ).matches &&
          pointers.size === 1 &&
          scale === 1
        ) {
          swipeStartX =
            event.clientX;

          swipeStartY =
            event.clientY;

          swipeTracking = true;
        }

        if (
          pointers.size === 2
        ) {
          swipeTracking = false;

          pinchStartDistance =
            pointerDistance();

          pinchStartScale =
            scale;

          dragging = false;

          return;
        }

        if (scale <= 1) {
          return;
        }

        dragging = true;

        pointerStartX =
          event.clientX;

        pointerStartY =
          event.clientY;

        translateStartX =
          translateX;

        translateStartY =
          translateY;

        viewport.classList.add(
          'is-dragging'
        );
      }
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (
          pointers.has(
            event.pointerId
          )
        ) {
          pointers.set(
            event.pointerId,
            {
              x: event.clientX,
              y: event.clientY
            }
          );
        }

        if (
          pointers.size === 2 &&
          pinchStartDistance > 0
        ) {
          const currentDistance =
            pointerDistance();

          setScale(
            pinchStartScale *
            (
              currentDistance /
              pinchStartDistance
            )
          );

          return;
        }

        if (!dragging) {
          return;
        }



        translateX =
          translateStartX +
          event.clientX -
          pointerStartX;
        translateY =
          translateStartY +
          event.clientY -
          pointerStartY;

        updateTransform();
      }
    );

    const finishPointer = (
      event,
      allowSwipe = false
    ) => {
      const desktop =
        window.matchMedia(
          '(min-width: 990px)'
        ).matches;

      const desktopDeltaX =
        event.clientX -
        desktopClickStartX;

      const desktopDeltaY =
        event.clientY -
        desktopClickStartY;

      const shouldToggleDesktopZoom =
        desktop &&
        desktopClickTracking &&
        pointers.size === 1 &&
        Math.abs(desktopDeltaX) <= 6 &&
        Math.abs(desktopDeltaY) <= 6;

      const shouldCheckSwipe =
        allowSwipe &&
        swipeTracking &&
        event.pointerType ===
        'touch' &&
        scale === 1 &&
        pointers.size === 1;

      const deltaX =
        event.clientX -
        swipeStartX;

      const deltaY =
        event.clientY -
        swipeStartY;

      pointers.delete(
        event.pointerId
      );

      if (
        pointers.size < 2
      ) {
        pinchStartDistance = 0;
      }

      dragging = false;

      viewport.classList.remove(
        'is-dragging'
      );

      swipeTracking = false;
      desktopClickTracking = false;

      if (
        shouldToggleDesktopZoom
      ) {
        if (scale > 1) {
          resetZoom();
        } else {
          setScale(1.5);
        }

        return;
      }

      if (
        !shouldCheckSwipe ||
        Math.abs(deltaX) <
        swipeThreshold ||
        Math.abs(deltaX) <=
        Math.abs(deltaY)
      ) {
        return;
      }

      if (deltaX < 0) {
        showImage(
          activeIndex + 1
        );
      } else {
        showImage(
          activeIndex - 1
        );
      }
    };

    viewport.addEventListener(
      'pointerup',
      (event) => {
        finishPointer(
          event,
          true
        );
      }
    );

    viewport.addEventListener(
      'pointercancel',
      (event) => {
        finishPointer(
          event,
          false
        );
      }
    );

    dialog.addEventListener(
      'cancel',
      (event) => {
        event.preventDefault();

        closeGallery();
      }
    );
  };





  const getPlanDiscountPercentage = (
    plan
  ) => {
    const compareAtPrice =
      Number(
        plan?.compareAtPrice ||
        0
      );

    const price =
      Number(
        plan?.price ||
        0
      );

    if (
      !compareAtPrice ||
      compareAtPrice <= price
    ) {
      return 0;
    }

    return Math.round(
      (
        (
          compareAtPrice -
          price
        ) /
        compareAtPrice
      ) *
      100
    );
  };









  const updatePurchaseCTA = (
    productRoot
  ) => {
    const controller =
      productControllers.get(
        productRoot
      );

    if (
      !controller ||
      !controller.selectedVariant
    ) {
      return;
    }

    const {
      selectedVariant,
      purchaseState
    } = controller;

    const button =
      productRoot.querySelector(
        '[data-julu-add-to-cart]'
      );

    const label =
      button?.querySelector(
        '[data-julu-atc-label]'
      );

    const price =
      button?.querySelector(
        '[data-julu-atc-price]'
      );

    let displayPrice =
      Number(
        selectedVariant.price
      );

    let buttonLabel =
      'Add to Cart';


    if (
      purchaseState.purchaseType ===
      'subscription'
    ) {
      const plan =
        selectedVariant
          .sellingPlans
          ?.find(
            (sellingPlan) =>
              Number(
                sellingPlan.id
              ) ===
              Number(
                purchaseState
                  .sellingPlanId
              )
          );

      if (plan) {
        displayPrice =
          Number(plan.price);

        buttonLabel =
          'Subscribe';
      }
    }


    if (price) {
      price.textContent =
        formatMoney(
          displayPrice,
          controller.currency
        );
    }


    if (label) {
      label.textContent =
        selectedVariant.available
          ? buttonLabel
          : 'Sold out';
    }


    if (button) {
      button.disabled =
        !selectedVariant.available;
    }
  };










  const initializePurchaseOptions = (
    productRoot
  ) => {
    const controller =
      productControllers.get(
        productRoot
      );

    if (!controller) {
      return;
    }


    const purchaseInputs =
      Array.from(
        productRoot.querySelectorAll(
          '[data-julu-purchase-type]'
        )
      );

    const oneTimeOption =
      productRoot.querySelector(
        '[data-julu-purchase-option="one-time"]'
      );

    const subscriptionOption =
      productRoot.querySelector(
        '[data-julu-purchase-option="subscription"]'
      );

    const planSelect =
      productRoot.querySelector(
        '[data-julu-selling-plan-select]'
      );

    const sellingPlanField =
      productRoot.querySelector(
        '[data-julu-form-selling-plan]'
      );

    const subscriptionPrice =
      productRoot.querySelector(
        '[data-julu-subscription-price]'
      );

    const subscriptionCompare =
      productRoot.querySelector(
        '[data-julu-subscription-compare]'
      );

    const subscriptionDiscount =
      productRoot.querySelector(
        '[data-julu-subscription-discount]'
      );

    const perDelivery =
      productRoot.querySelector(
        '[data-julu-subscription-per-delivery]'
      );

    const detailsWrap =
      productRoot.querySelector(
        '[data-julu-subscription-details-wrap]'
      );

    const detailsTrigger =
      productRoot.querySelector(
        '[data-julu-subscription-details-trigger]'
      );

    const detailsTooltip =
      productRoot.querySelector(
        '[data-julu-subscription-tooltip]'
      );

    const detailsDescription =
      productRoot.querySelector(
        '[data-julu-subscription-description]'
      );

    const subscriptionFeatures =
      productRoot.querySelector(
        '[data-julu-subscription-features]'
      );


    const getCurrentPlan =
      () => {
        const variant =
          controller.selectedVariant;

        if (
          !variant ||
          !variant.sellingPlans?.length
        ) {
          return null;
        }

        return (
          variant.sellingPlans.find(
            (plan) =>
              Number(plan.id) ===
              Number(
                controller
                  .purchaseState
                  .sellingPlanId
              )
          ) ||
          variant.sellingPlans[0]
        );
      };


    const syncFormState =
      () => {
        const state =
          controller.purchaseState;

        const variant =
          controller.selectedVariant;

        const variantField =
          productRoot.querySelector(
            '[data-julu-form-variant]'
          );


        if (
          variantField &&
          variant
        ) {
          variantField.value =
            variant.id;
        }


        if (
          state.purchaseType ===
          'subscription' &&
          state.sellingPlanId &&
          sellingPlanField
        ) {
          sellingPlanField.disabled =
            false;

          sellingPlanField.value =
            state.sellingPlanId;
        } else if (
          sellingPlanField
        ) {
          sellingPlanField.disabled =
            true;

          sellingPlanField.value =
            '';
        }
      };


    const updatePlanUI =
      () => {
        const plan =
          getCurrentPlan();


        if (!plan) {
          if (
            subscriptionPrice
          ) {
            subscriptionPrice.textContent =
              '';
          }

          if (
            subscriptionCompare
          ) {
            subscriptionCompare.hidden =
              true;

            subscriptionCompare.textContent =
              '';
          }

          if (
            subscriptionDiscount
          ) {
            subscriptionDiscount.hidden =
              true;

            subscriptionDiscount.textContent =
              '';
          }

          if (
            perDelivery
          ) {
            perDelivery.hidden =
              true;

            perDelivery.textContent =
              '';
          }

          syncFormState();

          updatePurchaseCTA(
            productRoot
          );

          return;
        }


        if (
          subscriptionPrice
        ) {
          subscriptionPrice.textContent =
            formatMoney(
              plan.price,
              controller.currency
            );
        }


        const hasCompare =
          Number(
            plan.compareAtPrice
          ) >
          Number(plan.price);


        if (
          subscriptionCompare
        ) {
          subscriptionCompare.hidden =
            !hasCompare;

          subscriptionCompare.textContent =
            hasCompare
              ? formatMoney(
                plan.compareAtPrice,
                controller.currency
              )
              : '';
        }


        const discount =
          getPlanDiscountPercentage(
            plan
          );


        if (
          subscriptionDiscount
        ) {
          subscriptionDiscount.hidden =
            discount <= 0;

          subscriptionDiscount.textContent =
            discount > 0
              ? `${discount}% OFF`
              : '';
        }


        const showPerDelivery =
          Number(
            plan.perDeliveryPrice
          ) > 0 &&
          Number(
            plan.perDeliveryPrice
          ) !==
          Number(plan.price);


        if (
          perDelivery
        ) {
          perDelivery.hidden =
            !showPerDelivery;

          perDelivery.textContent =
            showPerDelivery
              ? `${formatMoney(
                plan.perDeliveryPrice,
                controller.currency
              )} per delivery`
              : '';
        }


        if (
          detailsDescription
        ) {
          const fallback =
            detailsDescription.dataset
              .fallback ||
            '';

          detailsDescription.textContent =
            plan.description ||
            fallback;
        }


        syncFormState();

        updatePurchaseCTA(
          productRoot
        );
      };


    const rebuildPlanOptions =
      () => {
        const variant =
          controller.selectedVariant;

        const plans =
          variant
            ?.sellingPlans ||
          [];


        if (!planSelect) {
          return;
        }


        planSelect.innerHTML =
          '';


        plans.forEach(
          (plan) => {
            const option =
              document.createElement(
                'option'
              );

            option.value =
              plan.id;

            option.textContent =
              plan.name;

            planSelect.appendChild(
              option
            );
          }
        );


        const currentlySelected =
          plans.some(
            (plan) =>
              Number(plan.id) ===
              Number(
                controller
                  .purchaseState
                  .sellingPlanId
              )
          );


        if (
          !currentlySelected
        ) {
          controller
            .purchaseState
            .sellingPlanId =
            plans[0]?.id ||
            null;
        }


        if (
          controller
            .purchaseState
            .sellingPlanId
        ) {
          planSelect.value =
            String(
              controller
                .purchaseState
                .sellingPlanId
            );
        }
      };


    const renderPurchaseAvailability =
      () => {
        const variant =
          controller.selectedVariant;

        const plans =
          variant
            ?.sellingPlans ||
          [];

        const subscriptionAvailable =
          plans.length > 0;


        if (
          subscriptionOption
        ) {
          subscriptionOption.hidden =
            !subscriptionAvailable;

          subscriptionOption
            .classList
            .toggle(
              'is-unavailable',
              !subscriptionAvailable
            );

          const input =
            subscriptionOption
              .querySelector(
                '[data-julu-purchase-type]'
              );

          if (input) {
            input.disabled =
              !subscriptionAvailable;
          }
        }


        if (
          detailsWrap
        ) {
          detailsWrap.hidden =
            !subscriptionAvailable;
        }


        if (
          variant?.requiresSellingPlan &&
          subscriptionAvailable
        ) {
          controller
            .purchaseState
            .purchaseType =
            'subscription';

          if (
            oneTimeOption
          ) {
            oneTimeOption.hidden =
              true;
          }
        } else {
          if (
            oneTimeOption
          ) {
            oneTimeOption.hidden =
              false;
          }


          if (
            controller
              .purchaseState
              .purchaseType ===
            'subscription' &&
            !subscriptionAvailable
          ) {
            controller
              .purchaseState
              .purchaseType =
              'one-time';

            controller
              .purchaseState
              .sellingPlanId =
              null;
          }
        }


        rebuildPlanOptions();
      };


    const renderPurchaseSelection =
      () => {
        const state =
          controller.purchaseState;


        purchaseInputs.forEach(
          (input) => {
            const selected =
              input.value ===
              state.purchaseType;

            input.checked =
              selected;

            input
              .closest(
                '[data-julu-purchase-option]'
              )
              ?.classList.toggle(
                'is-selected',
                selected
              );
          }
        );


        if (
          subscriptionFeatures
        ) {
          subscriptionFeatures.hidden =
            state.purchaseType !==
            'subscription';
        }


        updatePlanUI();
      };


    const setPurchaseType =
      (purchaseType) => {
        const variant =
          controller.selectedVariant;

        const plans =
          variant
            ?.sellingPlans ||
          [];


        if (
          purchaseType ===
          'subscription' &&
          !plans.length
        ) {
          purchaseType =
            'one-time';
        }


        controller
          .purchaseState
          .purchaseType =
          purchaseType;


        if (
          purchaseType ===
          'subscription'
        ) {
          const stillValid =
            plans.some(
              (plan) =>
                Number(plan.id) ===
                Number(
                  controller
                    .purchaseState
                    .sellingPlanId
                )
            );


          if (!stillValid) {
            controller
              .purchaseState
              .sellingPlanId =
              plans[0]?.id ||
              null;
          }
        } else {
          controller
            .purchaseState
            .sellingPlanId =
            null;
        }


        renderPurchaseSelection();
      };


    const setSellingPlan =
      (sellingPlanId) => {
        const plans =
          controller
            .selectedVariant
            ?.sellingPlans ||
          [];


        const exists =
          plans.some(
            (plan) =>
              Number(plan.id) ===
              Number(
                sellingPlanId
              )
          );


        if (!exists) {
          return;
        }


        controller
          .purchaseState
          .purchaseType =
          'subscription';

        controller
          .purchaseState
          .sellingPlanId =
          Number(
            sellingPlanId
          );


        renderPurchaseSelection();
      };


    const refreshForVariant =
      (variant) => {
        controller
          .purchaseState
          .variantId =
          variant.id;


        renderPurchaseAvailability();

        renderPurchaseSelection();
      };


    purchaseInputs.forEach(
      (input) => {
        input.addEventListener(
          'change',
          () => {
            if (!input.checked) {
              return;
            }

            setPurchaseType(
              input.value
            );
          }
        );
      }
    );


    planSelect
      ?.addEventListener(
        'change',
        () => {
          setSellingPlan(
            planSelect.value
          );
        }
      );


    const closeDetails =
      () => {
        if (
          !detailsTooltip ||
          !detailsTrigger
        ) {
          return;
        }

        detailsTooltip.hidden =
          true;

        detailsTrigger.setAttribute(
          'aria-expanded',
          'false'
        );
      };


    detailsTrigger
      ?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();

          const open =
            detailsTooltip.hidden;

          detailsTooltip.hidden =
            !open;

          detailsTrigger.setAttribute(
            'aria-expanded',
            open
              ? 'true'
              : 'false'
          );
        }
      );


    document.addEventListener(
      'click',
      (event) => {
        if (
          !detailsWrap ||
          !detailsTooltip ||
          detailsTooltip.hidden ||
          detailsWrap.contains(
            event.target
          )
        ) {
          return;
        }

        closeDetails();
      }
    );


    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key !==
          'Escape'
        ) {
          return;
        }

        closeDetails();
      }
    );


    controller.refreshPurchaseForVariant =
      refreshForVariant;

    controller.setPurchaseType =
      setPurchaseType;

    controller.setSellingPlan =
      setSellingPlan;
  };






  const updateVariant = (
    productRoot,
    variant
  ) => {
    const controller =
      productControllers.get(
        productRoot
      );

    if (
      !controller ||
      !variant
    ) {
      return;
    }


    controller.selectedVariant =
      variant;


    productRoot
      .querySelectorAll(
        '[data-julu-variant-input]'
      )
      .forEach(
        (input) => {
          const selected =
            Number(input.value) ===
            Number(variant.id);

          input.checked =
            selected;

          input
            .closest(
              '[data-julu-pack-card]'
            )
            ?.classList.toggle(
              'is-active',
              selected
            );
        }
      );


    const productPrice =
      productRoot.querySelector(
        '[data-julu-product-price]'
      );

    if (productPrice) {
      productPrice.textContent =
        formatMoney(
          variant.price,
          controller.currency
        );
    }


    const productCompare =
      productRoot.querySelector(
        '[data-julu-product-compare]'
      );

    const productSale =
      productRoot.querySelector(
        '[data-julu-product-sale]'
      );

    const compareAtPrice =
      Number(
        variant.compareAtPrice ||
        0
      );

    const variantPrice =
      Number(
        variant.price ||
        0
      );

    const hasSale =
      compareAtPrice >
      variantPrice;

    const salePercentage =
      hasSale
        ? Math.round(
          (
            (
              compareAtPrice -
              variantPrice
            ) /
            compareAtPrice
          ) *
          100
        )
        : 0;

    if (productCompare) {
      productCompare.hidden =
        !hasSale;

      productCompare.textContent =
        hasSale
          ? formatMoney(
            compareAtPrice,
            controller.currency
          )
          : '';
    }

    if (productSale) {
      productSale.hidden =
        !hasSale;

      productSale.textContent =
        hasSale
          ? `${salePercentage}% OFF`
          : '';
    }

    const oneTimePrice =
      productRoot.querySelector(
        '[data-julu-one-time-price]'
      );

    if (oneTimePrice) {
      oneTimePrice.textContent =
        formatMoney(
          variant.price,
          controller.currency
        );
    }


    const oneTimeCompare =
      productRoot.querySelector(
        '[data-julu-one-time-compare]'
      );

    if (oneTimeCompare) {
      const hasCompare =
        Number(
          variant.compareAtPrice
        ) >
        Number(
          variant.price
        );

      oneTimeCompare.hidden =
        !hasCompare;

      oneTimeCompare.textContent =
        hasCompare
          ? formatMoney(
            variant.compareAtPrice,
            controller.currency
          )
          : '';
    }


    const unitPrice =
      productRoot.querySelector(
        '[data-julu-unit-price]'
      );

    if (unitPrice) {
      const units =
        Number(
          variant.units ||
          0
        );

      unitPrice.textContent =
        units > 0
          ? `${formatMoney(
            Number(
              variant.price
            ) /
            units,
            controller.currency
          )} per can`
          : '';
    }


    const variantField =
      productRoot.querySelector(
        '[data-julu-form-variant]'
      );

    if (variantField) {
      variantField.value =
        variant.id;
    }


    const addButton =
      productRoot.querySelector(
        '[data-julu-add-to-cart]'
      );

    if (addButton) {
      addButton.dataset
        .selectedImage =
        variant.imageSmall ||
        '';
    }






    controller
      .refreshPurchaseForVariant?.(
        variant
      );


    updatePurchaseCTA(
      productRoot
    );
  };


  const initializeVariants = (
    productRoot,
    productData
  ) => {
    productRoot
      .querySelectorAll(
        '[data-julu-variant-input]'
      )
      .forEach(
        (input) => {
          input.addEventListener(
            'change',
            () => {
              const controller =
                productControllers.get(
                  productRoot
                );

              const variant =
                controller
                  ?.variants
                  .get(
                    Number(
                      input.value
                    )
                  );

              updateVariant(
                productRoot,
                variant
              );
            }
          );
        }
      );


    const selectedVariant =
      productData.variants.find(
        (variant) =>
          Number(variant.id) ===
          Number(
            productData
              .selectedVariantId
          )
      ) ||
      productData.variants[0];


    if (selectedVariant) {
      updateVariant(
        productRoot,
        selectedVariant
      );
    }
  };


  const updateHeaderCart = (
    itemCount
  ) => {
    const cartLink =
      document.querySelector(
        '[data-julu-cart-open]'
      );

    if (!cartLink) {
      return;
    }


    cartLink.setAttribute(
      'aria-label',
      `Cart, ${itemCount} ${Number(itemCount) === 1
        ? 'item'
        : 'items'
      }`
    );


    let badge =
      cartLink.querySelector(
        '[data-julu-cart-count]'
      );


    if (
      Number(itemCount) <= 0
    ) {
      badge?.remove();

      return;
    }


    if (!badge) {
      badge =
        document.createElement(
          'span'
        );

      badge.className =
        'julu-header__cart-count';

      badge.dataset
        .juluCartCount =
        '';

      badge.setAttribute(
        'aria-hidden',
        'true'
      );

      cartLink.appendChild(
        badge
      );
    }


    badge.textContent =
      itemCount;
  };





  const getJuluCartDrawer =
    () => {
      return document.querySelector(
        'cart-drawer'
      );
    };


  const getJuluCartCount =
    () => {
      const drawer =
        getJuluCartDrawer();

      return Number(
        drawer
          ?.querySelector(
            '[data-julu-cart-count-value]'
          )
          ?.dataset
          .juluCartCountValue ||
        0
      );
    };


  const updateJuluCartCountUI =
    (itemCount) => {
      updateHeaderCart(
        itemCount
      );

      document
        .querySelectorAll(
          '[data-julu-drawer-count]'
        )
        .forEach((count) => {
          count.textContent =
            `(${itemCount})`;
        });
    };


  const renderJuluCartState = (
    state,
    {
      trigger = null,
      variantId = null
    } = {}
  ) => {
    const drawer =
      getJuluCartDrawer();

    if (
      !drawer ||
      !state?.sections?.[
      'cart-drawer'
      ]
    ) {
      return false;
    }

    if (
      trigger &&
      typeof drawer
        .setActiveElement ===
      'function'
    ) {
      drawer.setActiveElement(
        trigger
      );
    }

    drawer.renderContents(
      state
    );

    document.dispatchEvent(
      new CustomEvent(
        'julu:cart:updated',
        {
          detail: {
            cartData: state,
            source: 'julu'
          }
        }
      )
    );

    window.requestAnimationFrame(
      () => {
        const itemCount =
          getJuluCartCount();

        updateJuluCartCountUI(
          itemCount
        );

        if (variantId) {
          const line =
            drawer.querySelector(
              `[data-variant-id="${variantId}"]`
            );

          if (line) {
            line.classList.add(
              'is-highlighted'
            );

            window.setTimeout(
              () => {
                line.classList.remove(
                  'is-highlighted'
                );
              },
              1000
            );
          }
        }
      }
    );

    return true;
  };


  const requestJuluCartMutation =
    async (
      endpoint,
      payload,
      trigger
    ) => {
      trigger?.setAttribute(
        'aria-busy',
        'true'
      );

      if (trigger) {
        trigger.disabled = true;
      }

      try {
        const response =
          await fetch(
            `${getRouteRoot()}${endpoint}`,
            {
              method: 'POST',
              headers: {
                Accept:
                  'application/json',
                'Content-Type':
                  'application/json'
              },
              body:
                JSON.stringify({
                  ...payload,
                  sections: [
                    'cart-drawer'
                  ],
                  sections_url:
                    window.location
                      .pathname
                })
            }
          );

        const state =
          await response.json();

        if (!response.ok) {
          throw new Error(
            state.description ||
            state.message ||
            state.errors ||
            'Unable to update cart.'
          );
        }

        return state;
      } finally {
        trigger?.removeAttribute(
          'aria-busy'
        );

        if (trigger) {
          trigger.disabled =
            false;
        }
      }
    };



  const fetchJuluCart = async () => {
    const response =
      await fetch(
        `${getRouteRoot()}cart.js`,
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to load cart.'
      );
    }

    return response.json();
  };


  const getJuluCartLineByHandle = (
    cart,
    handle
  ) => {
    return (
      cart?.items?.find(
        (item) =>
          item.handle === handle
      ) || null
    );
  };


  const getJuluRewardSubtotal = (
    cart
  ) => {
    const excludedHandles =
      new Set([
        'julu-secure-delivery',
        'julu-pop-market-tote',
        'julu-mystery-drop'
      ]);

    return (
      cart?.items || []
    ).reduce(
      (
        subtotal,
        item
      ) => {
        if (
          excludedHandles.has(
            item.handle
          )
        ) {
          return subtotal;
        }

        return (
          subtotal +
          Number(
            item.final_line_price ||
            0
          )
        );
      },
      0
    );
  };


  const getJuluProtectionOptOut =
    () => {
      try {
        return (
          window.sessionStorage
            .getItem(
              'juluShippingProtectionOptOut'
            ) === 'true'
        );
      } catch (error) {
        return false;
      }
    };


  const setJuluProtectionOptOut =
    (optedOut) => {
      try {
        if (optedOut) {
          window.sessionStorage
            .setItem(
              'juluShippingProtectionOptOut',
              'true'
            );

          return;
        }

        window.sessionStorage
          .removeItem(
            'juluShippingProtectionOptOut'
          );
      } catch (error) {
        console.error(
          'Unable to save Shipping Protection preference.',
          error
        );
      }
    };




  const initializeCartDrawer =
    () => {
      const drawer =
        getJuluCartDrawer();

      if (
        !drawer ||
        drawer.dataset
          .juluCartInitialized ===
        'true'
      ) {
        return;
      }

      drawer.dataset
        .juluCartInitialized =
        'true';

      const touchInteraction =
        window.matchMedia(
          '(hover: none) and (pointer: coarse)'
        );

      let activeQuantity =
        null;

      let quantityTimer =
        null;


      let rewardSyncRunning =
        false;

      let rewardSyncQueued =
        false;

      let giftModalTrigger =
        null;

      let selectedGiftVariantId =
        null;


      drawer.addEventListener(
        'change',
        async (event) => {
          const protectionToggle =
            event.target.closest(
              '[data-julu-protection-toggle]'
            );

          if (!protectionToggle) {
            return;
          }

          const variantId =
            Number(
              protectionToggle.dataset
                .variantId
            );

          if (!variantId) {
            return;
          }

          protectionToggle.disabled =
            true;

          try {
            const cart =
              await fetchJuluCart();

            const protectionLine =
              getJuluCartLineByHandle(
                cart,
                'julu-secure-delivery'
              );

            if (
              protectionToggle.checked
            ) {
              setJuluProtectionOptOut(
                false
              );

              if (!protectionLine) {
                const state =
                  await requestJuluCartMutation(
                    'cart/add.js',
                    {
                      items: [
                        {
                          id:
                            variantId,
                          quantity: 1,
                          properties: {
                            _julu_utility:
                              'shipping_protection'
                          }
                        }
                      ]
                    },
                    protectionToggle
                  );

                renderJuluCartState(
                  state
                );
              }

              return;
            }

            setJuluProtectionOptOut(
              true
            );

            if (protectionLine) {
              const state =
                await requestJuluCartMutation(
                  'cart/change.js',
                  {
                    id:
                      protectionLine.key,
                    quantity: 0
                  },
                  protectionToggle
                );

              renderJuluCartState(
                state
              );
            }
          } catch (error) {
            protectionToggle.checked =
              !protectionToggle.checked;

            protectionToggle.disabled =
              false;

            const errors =
              drawer.querySelector(
                '#CartDrawer-CartErrors'
              );

            if (errors) {
              errors.textContent =
                error.message;
            }
          }
        }
      );






      drawer.addEventListener(
        'keydown',
        (event) => {
          const modal =
            drawer.querySelector(
              '[data-julu-gift-modal]'
            );

          if (
            !modal ||
            modal.hidden
          ) {
            return;
          }

          if (
            event.key ===
            'Escape'
          ) {
            event.preventDefault();

            closeGiftModal();
          }
        }
      );





      const collapseQuantity =
        () => {
          if (!activeQuantity) {
            return;
          }

          activeQuantity.classList
            .remove(
              'is-expanded'
            );

          activeQuantity =
            null;

          if (quantityTimer) {
            window.clearTimeout(
              quantityTimer
            );

            quantityTimer =
              null;
          }
        };


      const expandQuantity =
        (quantity) => {
          if (
            activeQuantity &&
            activeQuantity !== quantity
          ) {
            activeQuantity.classList
              .remove(
                'is-expanded'
              );
          }

          activeQuantity =
            quantity;

          quantity.classList.add(
            'is-expanded'
          );

          if (quantityTimer) {
            window.clearTimeout(
              quantityTimer
            );
          }

          quantityTimer =
            window.setTimeout(
              collapseQuantity,
              2600
            );
        };


      const getPromoCode =
        () => {
          try {
            return (
              window.sessionStorage
                .getItem(
                  'juluCartPromo'
                ) || ''
            );
          } catch (error) {
            return '';
          }
        };


      const hydratePromo =
        () => {
          const code =
            getPromoCode();

          const input =
            drawer.querySelector(
              '[data-julu-cart-promo-input]'
            );

          const message =
            drawer.querySelector(
              '[data-julu-cart-promo-message]'
            );

          if (
            input &&
            code
          ) {
            input.value = code;
          }

          if (
            message &&
            code
          ) {
            message.textContent =
              'Code saved. It will be applied at checkout.';
          }
        };


      let lastRewardSubtotal =
        Number(
          drawer.dataset
            .rewardSubtotal ||
          0
        );


      const getCrossedJuluRewards =
        (
          previousSubtotal,
          currentSubtotal
        ) => {
          if (
            currentSubtotal <=
            previousSubtotal
          ) {
            return [];
          }

          const rewards = [
            {
              name: 'shipping',
              threshold:
                Number(
                  drawer.dataset
                    .freeShippingThreshold ||
                  99900
                )
            },
            {
              name: 'gift',
              threshold:
                Number(
                  drawer.dataset
                    .freeGiftThreshold ||
                  139800
                )
            },
            {
              name: 'mystery',
              threshold:
                Number(
                  drawer.dataset
                    .mysteryGiftThreshold ||
                  199900
                )
            }
          ];

          return rewards.filter(
            (reward) =>
              previousSubtotal <
              reward.threshold &&
              currentSubtotal >=
              reward.threshold
          );
        };


      const addJuluRewardParticles =
        (rewardPoint) => {
          if (
            reducedMotion.matches
          ) {
            return;
          }

          const icon =
            rewardPoint.querySelector(
              '.julu-cart__reward-icon'
            );

          if (!icon) {
            return;
          }

          const fragment =
            document.createDocumentFragment();

          const particles = [];

          const particleCount = 10;

          const particleColors = [
            'var(--julu-cart-primary)',
            'var(--julu-cart-accent)',
            '#f6c344'
          ];

          for (
            let index = 0;
            index < particleCount;
            index += 1
          ) {
            const particle =
              document.createElement(
                'span'
              );

            const angle =
              (
                Math.PI * 2 *
                index
              ) /
              particleCount;

            const distance =
              24 +
              Math.random() * 18;

            const x =
              Math.cos(angle) *
              distance;

            const y =
              Math.sin(angle) *
              distance;

            particle.className =
              'julu-cart__reward-particle';

            particle.style.setProperty(
              '--julu-particle-x',
              `${x.toFixed(1)}px`
            );

            particle.style.setProperty(
              '--julu-particle-y',
              `${y.toFixed(1)}px`
            );

            particle.style.setProperty(
              '--julu-particle-rotate',
              `${Math.round(
                Math.random() * 180
              )}deg`
            );

            particle.style.setProperty(
              '--julu-particle-color',
              particleColors[
              index %
              particleColors.length
              ]
            );

            particles.push(
              particle
            );

            fragment.appendChild(
              particle
            );
          }

          icon.appendChild(
            fragment
          );

          window.setTimeout(
            () => {
              particles.forEach(
                (particle) => {
                  particle.remove();
                }
              );
            },
            900
          );
        };


      const celebrateJuluRewards =
        (crossedRewards) => {
          if (!crossedRewards.length) {
            return;
          }

          const rewardPoints =
            crossedRewards
              .map(
                (reward) =>
                  drawer.querySelector(
                    `[data-julu-reward-point="${reward.name}"]`
                  )
              )
              .filter(Boolean);

          if (!rewardPoints.length) {
            return;
          }

          rewardPoints.forEach(
            (rewardPoint) => {
              rewardPoint.classList.remove(
                'is-celebrating'
              );

              void rewardPoint.offsetWidth;

              rewardPoint.classList.add(
                'is-celebrating'
              );
            }
          );

          const highestRewardPoint =
            rewardPoints[
            rewardPoints.length - 1
            ];

          addJuluRewardParticles(
            highestRewardPoint
          );

          window.setTimeout(
            () => {
              rewardPoints.forEach(
                (rewardPoint) => {
                  rewardPoint.classList.remove(
                    'is-celebrating'
                  );
                }
              );
            },
            850
          );
        };


      const syncJuluCartRewards =
        async (
          cartState = null
        ) => {
          if (rewardSyncRunning) {
            rewardSyncQueued =
              true;

            return;
          }

          rewardSyncRunning =
            true;

          rewardSyncQueued =
            false;

          try {
            const protectionVariantId =
              Number(
                drawer.dataset
                  .shippingProtectionVariant ||
                0
              );

            const mysteryVariantId =
              Number(
                drawer.dataset
                  .mysteryGiftVariant ||
                0
              );

            const freeGiftThreshold =
              Number(
                drawer.dataset
                  .freeGiftThreshold ||
                139800
              );

            const mysteryThreshold =
              Number(
                drawer.dataset
                  .mysteryGiftThreshold ||
                199900
              );

            let cart =
              cartState ||
              await fetchJuluCart();

            let finalState =
              null;

            let rewardSubtotal =
              getJuluRewardSubtotal(
                cart
              );

            const hasQualifyingItems =
              cart.items.some(
                (item) =>
                  ![
                    'julu-secure-delivery',
                    'julu-pop-market-tote',
                    'julu-mystery-drop'
                  ].includes(
                    item.handle
                  )
              );


            let protectionLine =
              getJuluCartLineByHandle(
                cart,
                'julu-secure-delivery'
              );


            if (
              hasQualifyingItems &&
              !getJuluProtectionOptOut() &&
              !protectionLine &&
              protectionVariantId
            ) {
              finalState =
                await requestJuluCartMutation(
                  'cart/add.js',
                  {
                    items: [
                      {
                        id:
                          protectionVariantId,
                        quantity: 1,
                        properties: {
                          _julu_utility:
                            'shipping_protection'
                        }
                      }
                    ]
                  }
                );

              cart =
                await fetchJuluCart();

            }


            protectionLine =
              getJuluCartLineByHandle(
                cart,
                'julu-secure-delivery'
              );





            if (
  !hasQualifyingItems
) {
  setJuluProtectionOptOut(
    false
  );

  if (cart.items.length) {
    finalState =
      await requestJuluCartMutation(
        'cart/clear.js',
        {}
      );

    renderJuluCartState(
      finalState
    );
  }

  return;
}




            rewardSubtotal =
              getJuluRewardSubtotal(
                cart
              );


            const freeGiftLines =
              cart.items.filter(
                (item) =>
                  item.handle ===
                  'julu-pop-market-tote'
              );


            if (
              rewardSubtotal <
              freeGiftThreshold &&
              freeGiftLines.length
            ) {
              for (
                const giftLine
                of freeGiftLines
              ) {
                finalState =
                  await requestJuluCartMutation(
                    'cart/change.js',
                    {
                      id:
                        giftLine.key,
                      quantity: 0
                    }
                  );
              }

              cart =
                Array.isArray(
                  finalState?.items
                )
                  ? finalState
                  : await fetchJuluCart();
            }

            if (
              rewardSubtotal >=
              freeGiftThreshold &&
              freeGiftLines.length > 1
            ) {
              const extraGiftLines =
                freeGiftLines.slice(1);

              for (
                const giftLine
                of extraGiftLines
              ) {
                finalState =
                  await requestJuluCartMutation(
                    'cart/change.js',
                    {
                      id:
                        giftLine.key,
                      quantity: 0
                    }
                  );
              }

              cart =
                Array.isArray(
                  finalState?.items
                )
                  ? finalState
                  : await fetchJuluCart();
            }

            rewardSubtotal =
              getJuluRewardSubtotal(
                cart
              );


            let mysteryLine =
              getJuluCartLineByHandle(
                cart,
                'julu-mystery-drop'
              );


            if (
              rewardSubtotal >=
              mysteryThreshold &&
              !mysteryLine &&
              mysteryVariantId
            ) {
              finalState =
                await requestJuluCartMutation(
                  'cart/add.js',
                  {
                    items: [
                      {
                        id:
                          mysteryVariantId,
                        quantity: 1,
                        properties: {
                          _julu_reward:
                            'mystery_gift'
                        }
                      }
                    ]
                  }
                );

              cart =
                await fetchJuluCart();
            }


            mysteryLine =
              getJuluCartLineByHandle(
                cart,
                'julu-mystery-drop'
              );


            if (
              rewardSubtotal <
              mysteryThreshold &&
              mysteryLine
            ) {
              finalState =
                await requestJuluCartMutation(
                  'cart/change.js',
                  {
                    id:
                      mysteryLine.key,
                    quantity: 0
                  }
                );

              cart =
                Array.isArray(
                  finalState?.items
                )
                  ? finalState
                  : await fetchJuluCart();
            }


            if (finalState) {
              renderJuluCartState(
                finalState
              );
            }
          } catch (error) {
            console.error(
              'Unable to synchronize Julu cart rewards.',
              error
            );
          } finally {
            rewardSyncRunning =
              false;

            if (rewardSyncQueued) {
              rewardSyncQueued =
                false;

              window.requestAnimationFrame(
                syncJuluCartRewards
              );
            }
          }
        };



      document.addEventListener(
        'julu:cart:updated',
        async (event) => {
          hydratePromo();

          updateJuluCartCountUI(
            getJuluCartCount()
          );

          try {
            const eventCart =
              event.detail?.cartData;

            const isFullCart =
              Array.isArray(
                eventCart?.items
              ) &&
              typeof eventCart?.item_count ===
              'number';

            const cart =
              isFullCart
                ? eventCart
                : await fetchJuluCart();

            const rewardSubtotal =
              getJuluRewardSubtotal(
                cart
              );
            const crossedRewards =
              getCrossedJuluRewards(
                lastRewardSubtotal,
                rewardSubtotal
              );

            lastRewardSubtotal =
              rewardSubtotal;

            window.requestAnimationFrame(
              () => {
                celebrateJuluRewards(
                  crossedRewards
                );
              }
            );

            syncJuluCartRewards(
              cart
            );
          } catch (error) {
            console.error(
              'Unable to evaluate Julu reward celebration.',
              error
            );

            syncJuluCartRewards();
          }
        }
      );


      const openGiftModal =
        (trigger) => {
          const modal =
            drawer.querySelector(
              '[data-julu-gift-modal]'
            );

          if (!modal) {
            return;
          }

          giftModalTrigger =
            trigger;

          selectedGiftVariantId =
            null;

          modal.hidden =
            false;

          modal
            .querySelectorAll(
              '[data-julu-gift-option]'
            )
            .forEach(
              (option) => {
                option.classList
                  .remove(
                    'is-selected'
                  );

                option.setAttribute(
                  'aria-checked',
                  'false'
                );
              }
            );

          const confirmButton =
            modal.querySelector(
              '[data-julu-gift-confirm]'
            );

          if (confirmButton) {
            confirmButton.disabled =
              true;
          }

          window.requestAnimationFrame(
            () => {
              modal.classList.add(
                'is-open'
              );

              modal
                .querySelector(
                  '[data-julu-gift-modal-close]'
                )
                ?.focus();
            }
          );
        };


      const closeGiftModal =
        () => {
          const modal =
            drawer.querySelector(
              '[data-julu-gift-modal]'
            );

          if (!modal) {
            return;
          }

          modal.classList.remove(
            'is-open'
          );

          window.setTimeout(
            () => {
              modal.hidden =
                true;

              giftModalTrigger
                ?.focus();

              giftModalTrigger =
                null;
            },
            reducedMotion.matches
              ? 0
              : 180
          );
        };


      drawer.addEventListener(
        'click',
        async (event) => {
          const quantity =
            event.target.closest(
              '[data-julu-cart-quantity]'
            );

          if (
            quantity &&
            touchInteraction.matches
          ) {
            const quantityButton =
              event.target.closest(
                '.quantity__button'
              );

            if (
              !quantity.classList
                .contains(
                  'is-expanded'
                ) &&
              !quantityButton
            ) {
              event.preventDefault();

              expandQuantity(
                quantity
              );

              return;
            }

            if (quantityButton) {
              expandQuantity(
                quantity
              );
            }
          }


          const quickAdd =
            event.target.closest(
              '[data-julu-cart-quick-add]'
            );

          if (quickAdd) {
            const variantId =
              Number(
                quickAdd.dataset
                  .variantId
              );

            if (!variantId) {
              return;
            }

            try {
              const state =
                await requestJuluCartMutation(
                  'cart/add.js',
                  {
                    items: [
                      {
                        id:
                          variantId,
                        quantity: 1
                      }
                    ]
                  },
                  quickAdd
                );

              renderJuluCartState(
                state,
                {
                  trigger:
                    quickAdd,
                  variantId
                }
              );
            } catch (error) {
              const errors =
                drawer.querySelector(
                  '#CartDrawer-CartErrors'
                );

              if (errors) {
                errors.textContent =
                  error.message;
              }
            }

            return;
          }


          const subscribeButton =
            event.target.closest(
              '[data-julu-cart-subscribe]'
            );

          if (subscribeButton) {
            const lineKey =
              subscribeButton.dataset
                .lineKey;

            const sellingPlanId =
              Number(
                subscribeButton.dataset
                  .sellingPlanId
              );

            const quantityValue =
              Number(
                subscribeButton.dataset
                  .quantity ||
                1
              );

            if (
              !lineKey ||
              !sellingPlanId
            ) {
              return;
            }

            try {
              const state =
                await requestJuluCartMutation(
                  'cart/change.js',
                  {
                    id:
                      lineKey,
                    quantity:
                      quantityValue,
                    selling_plan:
                      sellingPlanId
                  },
                  subscribeButton
                );

              renderJuluCartState(
                state,
                {
                  trigger:
                    subscribeButton
                }
              );
            } catch (error) {
              const errors =
                drawer.querySelector(
                  '#CartDrawer-CartErrors'
                );

              if (errors) {
                errors.textContent =
                  error.message;
              }
            }

            return;
          }


          const giftOpen =
            event.target.closest(
              '[data-julu-gift-chooser-open]'
            );

          if (giftOpen) {
            event.preventDefault();

            openGiftModal(
              giftOpen
            );

            return;
          }


          const giftClose =
            event.target.closest(
              '[data-julu-gift-modal-close]'
            );

          if (giftClose) {
            event.preventDefault();

            closeGiftModal();

            return;
          }


          const giftOption =
            event.target.closest(
              '[data-julu-gift-option]'
            );

          if (giftOption) {
            event.preventDefault();

            selectedGiftVariantId =
              Number(
                giftOption.dataset
                  .variantId
              );

            giftOption
              .closest(
                '[data-julu-gift-modal]'
              )
              ?.querySelectorAll(
                '[data-julu-gift-option]'
              )
              .forEach(
                (option) => {
                  const selected =
                    option ===
                    giftOption;

                  option.classList
                    .toggle(
                      'is-selected',
                      selected
                    );

                  option.setAttribute(
                    'aria-checked',
                    selected
                      ? 'true'
                      : 'false'
                  );
                }
              );

            const confirmButton =
              drawer.querySelector(
                '[data-julu-gift-confirm]'
              );

            if (confirmButton) {
              confirmButton.disabled =
                !selectedGiftVariantId;
            }

            return;
          }


          const giftConfirm =
            event.target.closest(
              '[data-julu-gift-confirm]'
            );

          if (giftConfirm) {
            event.preventDefault();

            if (
              !selectedGiftVariantId
            ) {
              return;
            }

            giftConfirm.disabled =
              true;

            try {
              const cart =
                await fetchJuluCart();

              const rewardSubtotal =
                getJuluRewardSubtotal(
                  cart
                );

              const threshold =
                Number(
                  drawer.dataset
                    .freeGiftThreshold ||
                  139800
                );

              if (
                rewardSubtotal <
                threshold
              ) {
                throw new Error(
                  'Your cart no longer qualifies for the free gift.'
                );
              }

              const currentGift =
                getJuluCartLineByHandle(
                  cart,
                  'julu-pop-market-tote'
                );

              if (currentGift) {
                await requestJuluCartMutation(
                  'cart/change.js',
                  {
                    id:
                      currentGift.key,
                    quantity: 0
                  }
                );
              }

              const state =
                await requestJuluCartMutation(
                  'cart/add.js',
                  {
                    items: [
                      {
                        id:
                          selectedGiftVariantId,
                        quantity: 1,
                        properties: {
                          _julu_reward:
                            'free_gift'
                        }
                      }
                    ]
                  },
                  giftConfirm
                );

              closeGiftModal();

              renderJuluCartState(
                state,
                {
                  variantId:
                    selectedGiftVariantId
                }
              );
            } catch (error) {
              const errors =
                drawer.querySelector(
                  '#CartDrawer-CartErrors'
                );

              if (errors) {
                errors.textContent =
                  error.message;
              }

              giftConfirm.disabled =
                false;
            }

            return;
          }



          const upsellRemove =
            event.target.closest(
              '[data-julu-cart-upsell-remove]'
            );

          if (upsellRemove) {
            event.preventDefault();

            const lineKey =
              upsellRemove.dataset
                .lineKey;

            if (!lineKey) {
              return;
            }

            try {
              const state =
                await requestJuluCartMutation(
                  'cart/change.js',
                  {
                    id:
                      lineKey,
                    quantity: 0
                  },
                  upsellRemove
                );

              renderJuluCartState(
                state
              );
            } catch (error) {
              const errors =
                drawer.querySelector(
                  '#CartDrawer-CartErrors'
                );

              if (errors) {
                errors.textContent =
                  error.message;
              }
            }

            return;
          }

          const previous =
            event.target.closest(
              '[data-julu-cart-upsell-previous]'
            );

          const next =
            event.target.closest(
              '[data-julu-cart-upsell-next]'
            );

          if (
            previous ||
            next
          ) {
            const track =
              drawer.querySelector(
                '[data-julu-cart-upsell-track]'
              );

            const card =
              track?.querySelector(
                '.julu-cart__upsell-card'
              );

            if (
              !track ||
              !card
            ) {
              return;
            }

            const styles =
              window.getComputedStyle(
                track
              );

            const gap =
              parseFloat(
                styles.columnGap ||
                styles.gap ||
                0
              );

            const distance =
              card
                .getBoundingClientRect()
                .width +
              gap;

            track.scrollBy({
              left:
                previous
                  ? -distance
                  : distance,
              behavior:
                reducedMotion.matches
                  ? 'auto'
                  : 'smooth'
            });
          }


          const checkout =
            event.target.closest(
              '[data-julu-cart-checkout]'
            );

          if (checkout) {
            const giftRequired =
              checkout.dataset
                .juluGiftRequired
                ?.trim() ===
              'true';

            if (giftRequired) {
              event.preventDefault();

              openGiftModal(
                checkout
              );

              return;
            }

            const promoCode =
              getPromoCode();

            if (!promoCode) {
              return;
            }

            event.preventDefault();

            const checkoutPath =
              `${getRouteRoot()}checkout`;

            const discountURL =
              `${getRouteRoot()}discount/${encodeURIComponent(
                promoCode
              )}?redirect=${encodeURIComponent(
                checkoutPath
              )}`;

            window.location.assign(
              discountURL
            );
          }
        }
      );


      drawer.addEventListener(
        'submit',
        (event) => {
          const promoForm =
            event.target.closest(
              '[data-julu-cart-promo-form]'
            );

          if (!promoForm) {
            return;
          }

          event.preventDefault();

          const input =
            promoForm.querySelector(
              '[data-julu-cart-promo-input]'
            );

          const message =
            promoForm.querySelector(
              '[data-julu-cart-promo-message]'
            );

          const code =
            input?.value
              ?.trim();

          if (!code) {
            if (message) {
              message.textContent =
                'Enter a promo code.';
            }

            return;
          }

          try {
            window.sessionStorage
              .setItem(
                'juluCartPromo',
                code
              );
          } catch (error) { }

          if (message) {
            message.textContent =
              'Code saved. It will be applied at checkout.';
          }
        }
      );


      drawer.addEventListener(
        'julu:cart:rendered',
        () => {
          hydratePromo();

          updateJuluCartCountUI(
            getJuluCartCount()
          );
        }
      );



      document.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !touchInteraction
              .matches ||
            !activeQuantity
          ) {
            return;
          }

          if (
            activeQuantity.contains(
              event.target
            )
          ) {
            return;
          }

          collapseQuantity();
        }
      );



      hydratePromo();

      window.requestAnimationFrame(
        () => {
          updateJuluCartCountUI(
            getJuluCartCount()
          );

          syncJuluCartRewards();
        }
      );
    };





  const animateProductToCart = (
    button,
    imageUrl
  ) => {
    if (
      reducedMotion.matches
    ) {
      return;
    }

    const cart =
      document.querySelector(
        '[data-julu-cart-open]'
      );

    if (
      !cart ||
      !button
    ) {
      return;
    }


    const from =
      button.getBoundingClientRect();

    const to =
      cart.getBoundingClientRect();


    const flying =
      imageUrl
        ? document.createElement(
          'img'
        )
        : document.createElement(
          'span'
        );


    if (imageUrl) {
      flying.src =
        imageUrl;

      flying.alt = '';
    }


    Object.assign(
      flying.style,
      {
        position: 'fixed',
        zIndex: '9999',

        left:
          `${from.left +
          from.width / 2 -
          20}px`,

        top:
          `${from.top +
          from.height / 2 -
          20}px`,

        width: '40px',
        height: '40px',

        borderRadius: '50%',

        objectFit: 'cover',

        pointerEvents: 'none',

        background:
          'var(--julu-product-accent, #e5008d)'
      }
    );


    document.body.appendChild(
      flying
    );


    const deltaX =
      to.left +
      to.width / 2 -
      (
        from.left +
        from.width / 2
      );

    const deltaY =
      to.top +
      to.height / 2 -
      (
        from.top +
        from.height / 2
      );


    const animation =
      flying.animate(
        [
          {
            transform:
              'translate3d(0, 0, 0) scale(1)',

            opacity: 1
          },
          {
            transform:
              `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.28)`,

            opacity: 0.3
          }
        ],
        {
          duration: 360,

          easing:
            'cubic-bezier(0.22, 1, 0.36, 1)'
        }
      );


    animation.onfinish =
      () => {
        flying.remove();

        cart.animate(
          [
            {
              transform:
                'scale(1)'
            },
            {
              transform:
                'scale(1.14)'
            },
            {
              transform:
                'scale(1)'
            }
          ],
          {
            duration: 280,
            easing: 'ease-out'
          }
        );
      };
  };






  const initializeProductForm = (
    productRoot
  ) => {
    const form =
      productRoot.querySelector(
        '[data-julu-product-form]'
      );

    if (!form) {
      return;
    }

    form.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();

        const button =
          form.querySelector(
            '[data-julu-add-to-cart]'
          );

        const status =
          form.querySelector(
            '[data-julu-product-status]'
          );

        if (
          !button ||
          button.disabled
        ) {
          return;
        }

        const controller =
          productControllers.get(
            productRoot
          );

        const variant =
          controller
            ?.selectedVariant;

        if (
          !controller ||
          !variant
        ) {
          return;
        }

        if (
          controller
            .purchaseState
            .purchaseType ===
          'subscription'
        ) {
          const sellingPlanField =
            form.querySelector(
              '[data-julu-form-selling-plan]'
            );

          if (
            !sellingPlanField ||
            sellingPlanField.disabled ||
            !sellingPlanField.value
          ) {
            if (status) {
              status.textContent =
                'Please select a subscription frequency.';
            }

            return;
          }
        }

        button.disabled = true;

        button.setAttribute(
          'aria-busy',
          'true'
        );

        if (status) {
          status.textContent = '';
        }

        try {
          const formData =
            new FormData(form);

          formData.append(
            'sections',
            'cart-drawer'
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          const response =
            await fetch(
              `${getRouteRoot()}cart/add.js`,
              {
                method: 'POST',
                headers: {
                  Accept:
                    'application/json'
                },
                body:
                  formData
              }
            );

          const lineItem =
            await response.json();

          if (!response.ok) {
            throw new Error(
              lineItem.description ||
              lineItem.message ||
              'Unable to add this item.'
            );
          }

          const drawerRendered =
            renderJuluCartState(
              lineItem,
              {
                trigger:
                  button,
                variantId:
                  Number(
                    lineItem.variant_id ||
                    lineItem.id
                  )
              }
            );

          const currentCartCount =
            drawerRendered
              ? getJuluCartCount()
              : null;

          if (
            drawerRendered &&
            currentCartCount !== null
          ) {
            updateJuluCartCountUI(
              currentCartCount
            );
          }

          animateProductToCart(
            button,
            button.dataset
              .selectedImage
          );

          if (status) {
            status.textContent =
              controller
                .purchaseState
                .purchaseType ===
                'subscription'
                ? 'Subscription added to cart.'
                : 'Added to cart.';
          }


        } catch (error) {
          console.error(
            'Julu add to cart failed:',
            error
          );

          if (status) {
            status.textContent =
              error.message ||
              'Unable to add this item.';
          }
        } finally {
          button.removeAttribute(
            'aria-busy'
          );

          button.disabled =
            !controller
              ?.selectedVariant
              ?.available;
        }
      }
    );
  };








  const initializeDetails = (
    productRoot
  ) => {
    const details =
      productRoot.querySelector(
        '[data-julu-product-details]'
      );

    if (!details) {
      return;
    }


    const tabs =
      Array.from(
        details.querySelectorAll(
          '[data-julu-detail-tab]'
        )
      );

    const panels =
      Array.from(
        details.querySelectorAll(
          '[data-julu-detail-panel]'
        )
      );


    const activateDesktopTab =
      (name) => {
        tabs.forEach(
          (tab) => {
            const active =
              tab.dataset
                .juluDetailTab ===
              name;

            tab.classList.toggle(
              'is-active',
              active
            );

            tab.setAttribute(
              'aria-selected',
              active
                ? 'true'
                : 'false'
            );
          }
        );


        panels.forEach(
          (panel) => {
            panel.classList.toggle(
              'is-active',
              panel.dataset
                .juluDetailPanel ===
              name
            );
          }
        );
      };


    tabs.forEach(
      (tab) => {
        tab.addEventListener(
          'click',
          () => {
            activateDesktopTab(
              tab.dataset
                .juluDetailTab
            );
          }
        );
      }
    );


    details
      .querySelectorAll(
        '[data-julu-detail-toggle]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              const panel =
                button.closest(
                  '[data-julu-detail-panel]'
                );

              if (!panel) {
                return;
              }

              const open =
                !panel.classList
                  .contains(
                    'is-open'
                  );

              panel.classList.toggle(
                'is-open',
                open
              );

              button.setAttribute(
                'aria-expanded',
                open
                  ? 'true'
                  : 'false'
              );
            }
          );
        }
      );
  };


  const createReviewPlayer = (
    source,
    title = ''
  ) => {
    const player =
      document.createElement(
        'div'
      );

    player.className =
      'julu-product__video-player';


    const video =
      document.createElement(
        'video'
      );

    video.src =
      source;

    video.preload =
      'metadata';

    video.playsInline =
      true;

    video.autoplay =
      true;

    video.muted =
      true;

    video.controls =
      false;

    video.setAttribute(
      'disablepictureinpicture',
      ''
    );

    video.setAttribute(
      'controlslist',
      'nodownload noplaybackrate noremoteplayback'
    );


    if (title) {
      video.setAttribute(
        'aria-label',
        title
      );
    }


    const playButton =
      document.createElement(
        'button'
      );

    playButton.type =
      'button';

    playButton.className =
      'julu-product__video-control julu-product__video-control--play';

    playButton.setAttribute(
      'aria-label',
      'Pause video'
    );

    playButton.innerHTML = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-julu-icon-play
    >
      <path
        d="m9 7 8 5-8 5Z"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-julu-icon-pause
    >
      <path
        d="M8 6h3v12H8zM13 6h3v12h-3z"
        fill="currentColor"
      />
    </svg>
  `;


    const muteButton =
      document.createElement(
        'button'
      );

    muteButton.type =
      'button';

    muteButton.className =
      'julu-product__video-control julu-product__video-control--mute';

    muteButton.setAttribute(
      'aria-label',
      'Unmute video'
    );

    muteButton.innerHTML = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-julu-icon-muted
    >
      <path
        d="M4 10v4h4l5 4V6l-5 4H4Z"
        fill="currentColor"
      />

      <path
        d="m17 9 4 6M21 9l-4 6"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>

    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-julu-icon-volume
    >
      <path
        d="M4 10v4h4l5 4V6l-5 4H4Z"
        fill="currentColor"
      />

      <path
        d="M16 9a4 4 0 0 1 0 6M18 6a8 8 0 0 1 0 12"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  `;


    player.append(
      video,
      playButton,
      muteButton
    );


    const updatePlayState =
      () => {
        const isPlaying =
          !video.paused &&
          !video.ended;

        playButton.classList.toggle(
          'is-playing',
          isPlaying
        );

        playButton.setAttribute(
          'aria-label',
          isPlaying
            ? 'Pause video'
            : 'Play video'
        );
      };


    const updateMuteState =
      () => {
        const isUnmuted =
          !video.muted;

        muteButton.classList.toggle(
          'is-unmuted',
          isUnmuted
        );

        muteButton.setAttribute(
          'aria-label',
          isUnmuted
            ? 'Mute video'
            : 'Unmute video'
        );
      };


    playButton.addEventListener(
      'click',
      () => {
        if (video.paused) {
          video
            .play()
            .catch(
              () => { }
            );
        } else {
          video.pause();
        }
      }
    );


    muteButton.addEventListener(
      'click',
      () => {
        video.muted =
          !video.muted;

        updateMuteState();
      }
    );


    video.addEventListener(
      'play',
      updatePlayState
    );

    video.addEventListener(
      'pause',
      updatePlayState
    );

    video.addEventListener(
      'ended',
      updatePlayState
    );

    video.addEventListener(
      'volumechange',
      updateMuteState
    );


    updatePlayState();

    updateMuteState();


    video
      .play()
      .catch(
        () => {
          updatePlayState();
        }
      );


    return {
      player,
      video
    };
  };


  const initializeReviews = (
    productRoot
  ) => {
    const module =
      productRoot.querySelector(
        '[data-julu-review-module]'
      );

    if (!module) {
      return;
    }


    const track =
      module.querySelector(
        '[data-julu-review-track]'
      );

    const navigation =
      module.querySelector(
        '[data-julu-review-navigation]'
      );

    const previousButton =
      module.querySelector(
        '[data-julu-review-previous]'
      );

    const nextButton =
      module.querySelector(
        '[data-julu-review-next]'
      );

    const reviewButtons =
      Array.from(
        module.querySelectorAll(
          '[data-julu-review-video]'
        )
      );

    const dialog =
      module.querySelector(
        '[data-julu-video-dialog]'
      );

    const dialogContent =
      module.querySelector(
        '[data-julu-video-dialog-content]'
      );

    const closeButton =
      module.querySelector(
        '[data-julu-video-close]'
      );


    let activeReviewIndex =
      0;

    let scrollFrame =
      null;


    const getScrollStep =
      () => {
        const firstCard =
          track?.querySelector(
            '[data-julu-review-video]'
          );

        if (
          !track ||
          !firstCard
        ) {
          return 0;
        }


        const cardWidth =
          firstCard
            .getBoundingClientRect()
            .width;

        const trackStyles =
          window.getComputedStyle(
            track
          );

        const gap =
          parseFloat(
            trackStyles.columnGap ||
            trackStyles.gap ||
            0
          );


        return (
          cardWidth +
          gap
        );
      };


    const updateNavigationState =
      () => {
        if (
          !track ||
          !navigation ||
          !previousButton ||
          !nextButton
        ) {
          return;
        }


        const reviewCount =
          reviewButtons.length;

        const hasOverflow =
          track.scrollWidth >
          track.clientWidth + 2;

        const shouldShow =
          reviewCount >= 4 &&
          hasOverflow;


        navigation.hidden =
          !shouldShow;


        if (!shouldShow) {
          previousButton.disabled =
            true;

          nextButton.disabled =
            true;

          return;
        }


        const maxScrollLeft =
          Math.max(
            0,
            track.scrollWidth -
            track.clientWidth
          );

        const currentScroll =
          Math.max(
            0,
            track.scrollLeft
          );

        const atStart =
          currentScroll <= 2;

        const atEnd =
          currentScroll >=
          maxScrollLeft - 2;


        previousButton.disabled =
          atStart;

        nextButton.disabled =
          atEnd;
      };


    const scheduleNavigationUpdate =
      () => {
        if (scrollFrame) {
          cancelAnimationFrame(
            scrollFrame
          );
        }


        scrollFrame =
          requestAnimationFrame(
            () => {
              updateNavigationState();

              scrollFrame = null;
            }
          );
      };


    const scrollReviews =
      (direction) => {
        if (!track) {
          return;
        }


        const step =
          getScrollStep();

        if (!step) {
          return;
        }


        track.scrollBy({
          left:
            step *
            direction,

          behavior:
            reducedMotion.matches
              ? 'auto'
              : 'smooth'
        });
      };


    previousButton
      ?.addEventListener(
        'click',
        () => {
          if (
            previousButton.disabled
          ) {
            return;
          }

          scrollReviews(-1);
        }
      );


    nextButton
      ?.addEventListener(
        'click',
        () => {
          if (
            nextButton.disabled
          ) {
            return;
          }

          scrollReviews(1);
        }
      );


    track?.addEventListener(
      'scroll',
      scheduleNavigationUpdate,
      {
        passive: true
      }
    );


    const resizeObserver =
      'ResizeObserver' in window
        ? new ResizeObserver(
          () => {
            scheduleNavigationUpdate();
          }
        )
        : null;


    if (resizeObserver && track) {
      resizeObserver.observe(
        track
      );
    } else {
      window.addEventListener(
        'resize',
        scheduleNavigationUpdate
      );
    }


    const closeDialog =
      () => {
        const video =
          dialogContent
            ?.querySelector(
              'video'
            );


        video?.pause();


        if (dialogContent) {
          dialogContent.innerHTML =
            '';
        }


        if (dialog?.open) {
          dialog.close();
        } else {
          dialog?.removeAttribute(
            'open'
          );
        }


        rootElement.classList.remove(
          'julu-product-video-open'
        );
      };


    const openReview =
      (reviewIndex) => {
        const reviewButton =
          reviewButtons[
          reviewIndex
          ];


        if (!reviewButton) {
          return;
        }


        const source =
          reviewButton.dataset
            .videoSrc;

        const title =
          reviewButton.dataset
            .videoTitle;


        if (!source) {
          return;
        }


        activeReviewIndex =
          reviewIndex;


        if (
          productRoot.dataset
            .reviewPlayback ===
          'inline'
        ) {
          const {
            player
          } =
            createReviewPlayer(
              source,
              title
            );

          reviewButton.replaceWith(
            player
          );

          return;
        }


        if (
          !dialog ||
          !dialogContent
        ) {
          return;
        }


        dialogContent.innerHTML =
          '';


        const {
          player
        } =
          createReviewPlayer(
            source,
            title
          );


        dialogContent.appendChild(
          player
        );


        if (
          typeof dialog.showModal ===
          'function'
        ) {
          dialog.showModal();
        } else {
          dialog.setAttribute(
            'open',
            ''
          );
        }


        rootElement.classList.add(
          'julu-product-video-open'
        );
      };


    reviewButtons.forEach(
      (
        button,
        index
      ) => {
        button.addEventListener(
          'click',
          () => {
            openReview(index);
          }
        );
      }
    );


    closeButton
      ?.addEventListener(
        'click',
        closeDialog
      );


    dialog?.addEventListener(
      'cancel',
      (event) => {
        event.preventDefault();

        closeDialog();
      }
    );


    dialog?.addEventListener(
      'click',
      (event) => {
        if (
          event.target ===
          dialog
        ) {
          closeDialog();
        }
      }
    );


    document.addEventListener(
      'keydown',
      (event) => {
        if (
          !dialog?.open
        ) {
          return;
        }


        if (
          event.key ===
          'Escape'
        ) {
          closeDialog();

          return;
        }


        if (
          event.key ===
          'ArrowLeft' &&
          activeReviewIndex > 0
        ) {
          openReview(
            activeReviewIndex - 1
          );
        }


        if (
          event.key ===
          'ArrowRight' &&
          activeReviewIndex <
          reviewButtons.length - 1
        ) {
          openReview(
            activeReviewIndex + 1
          );
        }
      }
    );


    requestAnimationFrame(
      updateNavigationState
    );
  };


  const lazyInitialize = (
    productRoot,
    selector,
    callback
  ) => {
    const target =
      productRoot.querySelector(
        selector
      );

    if (!target) {
      return;
    }


    if (
      !(
        'IntersectionObserver' in
        window
      )
    ) {
      callback(productRoot);

      return;
    }


    const observer =
      new IntersectionObserver(
        (entries) => {
          const visible =
            entries.some(
              (entry) =>
                entry.isIntersecting
            );

          if (!visible) {
            return;
          }

          observer.disconnect();

          callback(
            productRoot
          );
        },
        {
          rootMargin:
            '300px 0px'
        }
      );


    observer.observe(
      target
    );
  };


  const fetchProductSection =
    async (
      productUrl,
      sectionId
    ) => {
      const url =
        new URL(
          productUrl,
          window.location.origin
        );

      const cacheKey =
        `${url.pathname}${url.search}?section_id=${sectionId}`;


      if (
        sectionCache.has(
          cacheKey
        )
      ) {
        return sectionCache.get(
          cacheKey
        );
      }


      url.searchParams.set(
        'section_id',
        sectionId
      );


      const request =
        fetch(
          url.toString(),
          {
            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        )
          .then(
            async (response) => {
              if (!response.ok) {
                throw new Error(
                  'Product section request failed.'
                );
              }

              return response.text();
            }
          )
          .catch(
            (error) => {
              sectionCache.delete(
                cacheKey
              );

              throw error;
            }
          );


      sectionCache.set(
        cacheKey,
        request
      );


      return request;
    };


  const swapProduct = async (
    currentRoot,
    productUrl,
    pushHistory = true
  ) => {
    if (
      !currentRoot ||
      currentRoot.classList
        .contains(
          'is-switching'
        )
    ) {
      return;
    }


    const sectionId =
      currentRoot.dataset
        .sectionId;


    if (!sectionId) {
      window.location.href =
        productUrl;

      return;
    }


    currentRoot.classList.add(
      'is-switching'
    );

    currentRoot.setAttribute(
      'aria-busy',
      'true'
    );


    try {
      const html =
        await fetchProductSection(
          productUrl,
          sectionId
        );


      const parsed =
        new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );


      const incoming =
        parsed.querySelector(
          productSelector
        );


      if (!incoming) {
        throw new Error(
          'Incoming Julu product section was not found.'
        );
      }


      currentRoot.replaceWith(
        incoming
      );


      applyGlobalTheme(
        incoming
      );


      initializeProduct(
        incoming
      );


      if (pushHistory) {
        history.pushState(
          {
            juluProduct:
              true
          },
          '',
          incoming.dataset
            .productUrl ||
          productUrl
        );
      }


      if (
        incoming.dataset
          .productTitle
      ) {
        document.title =
          incoming.dataset
            .productTitle;
      }
    } catch (error) {
      window.location.href =
        productUrl;
    }
  };


  const initializeFlavorLinks = (
    productRoot
  ) => {
    const flavourSelect =
      productRoot.querySelector(
        '[data-julu-flavour-select]'
      );

    const flavourTrigger =
      flavourSelect?.querySelector(
        '[data-julu-flavour-select-trigger]'
      );

    const closeFlavourSelect =
      () => {
        if (
          !flavourSelect ||
          !flavourTrigger
        ) {
          return;
        }

        flavourSelect.classList.remove(
          'is-open'
        );

        flavourTrigger.setAttribute(
          'aria-expanded',
          'false'
        );
      };

    flavourTrigger?.addEventListener(
      'click',
      () => {
        const open =
          !flavourSelect.classList
            .contains(
              'is-open'
            );

        flavourSelect.classList.toggle(
          'is-open',
          open
        );

        flavourTrigger.setAttribute(
          'aria-expanded',
          open
            ? 'true'
            : 'false'
        );
      }
    );

    flavourSelect?.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key !==
          'Escape'
        ) {
          return;
        }

        closeFlavourSelect();

        flavourTrigger?.focus();
      }
    );

    flavourSelect?.addEventListener(
      'focusout',
      (event) => {
        if (
          flavourSelect.contains(
            event.relatedTarget
          )
        ) {
          return;
        }

        closeFlavourSelect();
      }
    );

    productRoot
      .querySelectorAll(
        '[data-julu-flavor-link]'
      )
      .forEach(
        (link) => {
          link.addEventListener(
            'click',
            closeFlavourSelect
          );

          if (
            link.getAttribute(
              'aria-current'
            ) ===
            'page'
          ) {
            return;
          }

          if (
            window.Shopify
              ?.designMode
          ) {
            return;
          }

          const prefetch =
            () => {
              fetchProductSection(
                link.href,
                productRoot.dataset
                  .sectionId
              ).catch(
                () => { }
              );
            };

          link.addEventListener(
            'pointerenter',
            prefetch,
            {
              once: true
            }
          );

          link.addEventListener(
            'focus',
            prefetch,
            {
              once: true
            }
          );

          link.addEventListener(
            'pointerdown',
            prefetch,
            {
              once: true
            }
          );

          link.addEventListener(
            'click',
            (event) => {
              if (
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
              ) {
                return;
              }

              event.preventDefault();

              swapProduct(
                productRoot,
                link.href,
                true
              );
            }
          );
        }
      );
  };

  const initializeProduct = (
    productRoot
  ) => {
    if (
      productRoot.dataset
        .juluProductInitialized ===
      'true'
    ) {
      return;
    }


    const productData =
      parseProductData(
        productRoot
      );


    if (!productData) {
      return;
    }


    productRoot.dataset
      .juluProductInitialized =
      'true';


    const variants =
      new Map(
        productData.variants.map(
          (variant) => [
            Number(
              variant.id
            ),
            variant
          ]
        )
      );


    productControllers.set(
      productRoot,
      {
        variants,

        currency:
          productData.currency,

        selectedVariant:
          null,

        purchaseState: {
          variantId:
            Number(
              productData
                .selectedVariantId
            ),

          purchaseType:
            'one-time',

          sellingPlanId:
            null
        },

        refreshPurchaseForVariant:
          null,

        setPurchaseType:
          null,

        setSellingPlan:
          null
      }
    );

    applyGlobalTheme(
      productRoot
    );


    initializeGallery(
      productRoot
    );


    initializeZoomGallery(
      productRoot
    );


    initializePurchaseOptions(
      productRoot
    );


    initializeVariants(
      productRoot,
      productData
    );


    initializeProductForm(
      productRoot
    );


    initializeFlavorLinks(
      productRoot
    );


    lazyInitialize(
      productRoot,
      '[data-julu-product-details]',
      initializeDetails
    );


    lazyInitialize(
      productRoot,
      '[data-julu-review-module]',
      initializeReviews
    );
  };


  const initializeProducts = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        productSelector
      )
    ) {
      initializeProduct(
        scope
      );
    }


    scope
      .querySelectorAll?.(
        productSelector
      )
      .forEach(
        (productRoot) => {
          initializeProduct(
            productRoot
          );
        }
      );
  };

  const initializeFooter = (
    scope = document
  ) => {
    const footers = [];

    if (
      scope.matches?.(
        '.julu-footer'
      )
    ) {
      footers.push(scope);
    }

    scope
      .querySelectorAll?.(
        '.julu-footer'
      )
      .forEach(
        (footer) => {
          footers.push(footer);
        }
      );


    footers.forEach(
      (footer) => {
        if (
          footer.dataset
            .juluFooterInitialized ===
          'true'
        ) {
          return;
        }

        footer.dataset
          .juluFooterInitialized =
          'true';

        const menus =
          Array.from(
            footer.querySelectorAll(
              '[data-julu-footer-menu]'
            )
          );

        const desktopMedia =
          window.matchMedia(
            '(min-width: 750px)'
          );


        const syncMenus =
          () => {
            menus.forEach(
              (menu) => {
                if (
                  desktopMedia.matches
                ) {
                  menu.open = true;

                  return;
                }

                menu.open = false;
              }
            );
          };


        syncMenus();

        desktopMedia.addEventListener?.(
          'change',
          syncMenus
        );
      }
    );
  };



  const initializeJulu = (
    scope = document
  ) => {
    initHeader(scope);

    initAnnouncementBars(scope);

    initializeProducts(scope);

    initializeCartDrawer();
  };


  window.addEventListener(
    'popstate',
    () => {
      const productRoot =
        document.querySelector(
          productSelector
        );

      if (!productRoot) {
        return;
      }


      const currentUrl =
        new URL(
          productRoot.dataset
            .productUrl,
          window.location.origin
        );


      if (
        currentUrl.pathname ===
        window.location.pathname
      ) {
        return;
      }


      swapProduct(
        productRoot,
        window.location.href,
        false
      );
    }
  );


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeJulu(
        event.target
      );
    }
  );


  initializeJulu();
})();